<script setup lang="ts">
import { IconInfoCircle } from '@tabler/icons-vue'
import { computed } from 'vue'

import StatusMessage from '@tix/ds/components/atoms/StatusMessage.vue'
import { useI18n } from '@tix/language'

import { getAuthMethod } from '@/helpers/auth'
import { getEnv } from '@/helpers/environment'

import { useCartStore } from '@/stores/cart'
import { useIdentityStore } from '@/stores/identity'

import LoginLink from '@/components/LoginLink.vue'
import MembershipLink from '@/components/MembershipLink.vue'
import PortalString from '@/components/PortalString.vue'

const { t } = useI18n()

const identityStore = useIdentityStore()
const cartStore = useCartStore()

const promoOk = computed(() => {
  const raw = getEnv().language_strings?.members_banner
  return raw == null || raw.length > 0
})

const enabled = computed(() => {
  const hasMembershipEvent = Boolean(getEnv().config?.web?.membership_event_id)
  return Boolean(
    hasMembershipEvent &&
    getAuthMethod() &&
    promoOk.value &&
    !(cartStore.inCartMembership() && !identityStore.isCurrentMember),
  )
})

const welcome = computed(() => t('membersBanner.welcomeBack', { name: identityStore.firstName }))
</script>

<template>
  <template v-if="enabled">
    <StatusMessage v-if="identityStore.isLoggedIn" :heading="welcome" variant="success" />
    <StatusMessage v-else :icon="IconInfoCircle" variant="neutral">
      <PortalString :components="{ LoginLink, MembershipLink }" name="custom_strings.members_banner" />
    </StatusMessage>
  </template>
</template>
